<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M8.4 2.39999c-.63652 0-1.24697.25286-1.69706.70295C6.25286 3.55302 6 4.16347 6 4.79999V19.2c0 .6365.25286 1.247.70294 1.6971.45009.45 1.06054.7029 1.69706.7029h7.2c.6365 0 1.247-.2529 1.6971-.7029.45-.4501.7029-1.0606.7029-1.6971V4.79999c0-.63652-.2529-1.24697-.7029-1.69705-.4501-.45009-1.0606-.70295-1.6971-.70295H8.4ZM12 19.2c.3183 0 .6235-.1264.8485-.3515.2251-.225.3515-.5302.3515-.8485s-.1264-.6235-.3515-.8485c-.225-.2251-.5302-.3515-.8485-.3515s-.6235.1264-.8485.3515c-.2251.225-.3515.5302-.3515.8485s.1264.6235.3515.8485c.225.2251.5302.3515.8485.3515Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M5.87868 2.87868C6.44129 2.31607 7.20435 2 8 2h8c.7956 0 1.5587.31607 2.1213.87868C18.6839 3.44129 19 4.20435 19 5v14c0 .7957-.3161 1.5587-.8787 2.1213C17.5587 21.6839 16.7957 22 16 22H8c-.79565 0-1.55871-.3161-2.12132-.8787C5.31607 20.5587 5 19.7957 5 19V5c0-.79565.31607-1.55871.87868-2.12132ZM8 4c-.26522 0-.51957.10536-.70711.29289C7.10536 4.48043 7 4.73478 7 5v14c0 .2652.10536.5196.29289.7071C7.48043 19.8946 7.73478 20 8 20h8c.2652 0 .5196-.1054.7071-.2929S17 19.2652 17 19V5c0-.26522-.1054-.51957-.2929-.70711C16.5196 4.10536 16.2652 4 16 4H8Zm3 14c0-.5523.4477-1 1-1h.01c.5523 0 1 .4477 1 1s-.4477 1-1 1H12c-.5523 0-1-.4477-1-1Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
